import { Form, Row, Col, Space, Card, Typography, message, Radio, Select, Checkbox, Alert } from "antd";
import { AntdButton, CheckboxField, InputField, SelectInput, TextareaField } from "../../../blueplanitUtils/InputField";
import { useDispatch, useSelector } from "react-redux";
import { ADD_EDIT_EMPLOYEE, BASIC_INFO, EMPLOYEE_DEPARTMENT, EMPLOYMENT_TYPE, WORK_TYPE } from "../../../Dropdownmanager";
import { getOptionsByPath } from "../../../utilsdata";
import { useEffect, useRef, useState } from "react";
import { createJobAsync } from "../../../Slices/hiringSlice";
import RichTextEditor from "../../../blueplanitUtils/RichTextEditor";

const AddJobRequisition = ({ setOpen }) => {
    const descriptionRef = useRef(null);
    const responsibilitiesRef = useRef(null);
    const dispatch = useDispatch();
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const details = useSelector((state) => state.employee.AllEmployees);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const [filteredEmployees, setFilteredEmployees] = useState([]);

    console.log(details)

    const [formData, setFormData] = useState({
        requisitionId: "",
        designation: "",
        dept: "",
        assignedTo: "",
        location: "",
        employmentType: "",
        workMode: "",
        numberOfOpenings: "",
        experienceRequired: "",
        skillsRequired: [],
        jobDescription: "",
        jobResponsibilities: "",
        salaryRange: "",
        shift: "",
        reasonForHiring: "",
        notes: "",
        approvalStatus: "Open",
        status: "Requested",
        RequestedBy: "",
        hasQuestions: "No",   // ✅ NEW
        questions: [],
        hasInterviewQuestions: "No",
        interviewQuestions: [],
        deptForInterview: "",
        hasExam: "No",
        exam: {
            enabled: false,
            examTitle: "",
            examLink: "",
            durationInMinutes: 45,
            instructions: "",
            passingScore: "",
            questions: []
        }

    });

    useEffect(() => {
        if (Array.isArray(formData.questions)) {
            const normalized = formData.questions.map(q =>
                typeof q === "string"
                    ? {
                        id: `q_${Date.now()}`,
                        label: q,
                        type: "input",
                        options: [],
                        required: true
                    }
                    : q
            );

            setFormData(prev => ({ ...prev, questions: normalized }));
        }
    }, []);

    // const handleChange = (field, value) => {
    //     setFormData((prev) => ({
    //         ...prev,
    //         [field]: value
    //     }));
    // };

    const addQuestion = () => {
        setFormData(prev => ({
            ...prev,
            questions: [
                ...prev.questions,
                {
                    id: `q_${Date.now()}`,
                    label: "",
                    type: "input",
                    options: [],
                    required: true
                }
            ]
        }));
    };



    const updateQuestion = (index, field, value) => {
        const updated = [...formData.questions];

        if (typeof updated[index] === "string") {
            updated[index] = {
                id: `q_${Date.now()}`,
                label: updated[index],
                type: "input",
                options: [],
                required: true
            };
        }

        updated[index][field] = value;

        if (
            field === "type" &&
            !["radio", "checkbox", "select"].includes(value)
        ) {
            updated[index].options = [];
        }

        setFormData(prev => ({
            ...prev,
            questions: updated
        }));
    };


    const addOption = (qIndex) => {
        const updated = [...formData.questions];
        updated[qIndex].options.push("");
        setFormData({ ...formData, questions: updated });
    };

    const updateOption = (qIndex, optIndex, value) => {
        const updated = [...formData.questions];
        updated[qIndex].options[optIndex] = value;
        setFormData({ ...formData, questions: updated });
    };

    const removeOption = (qIndex, optIndex) => {
        const updated = [...formData.questions];
        updated[qIndex].options = updated[qIndex].options.filter((_, i) => i !== optIndex);
        setFormData({ ...formData, questions: updated });
    };


    const removeQuestion = (index) => {
        setFormData(prev => ({
            ...prev,
            questions: prev.questions.filter((_, i) => i !== index)
        }));
    };

    const handleChange = (key, value) => {
        const updatedForm = {
            ...formData,
            [key]: value,
        };
        setFormData(updatedForm);
    };

    const assignedToOptions = details.map((emp) => ({
        label: emp.firstname + " " + emp.lastname,
        value: emp.id,
    }));

    const addInterviewQuestion = () => {
        setFormData(prev => ({
            ...prev,
            interviewQuestions: [
                ...prev.interviewQuestions,
                {
                    question: "",
                    category: "Technical",
                    required: true
                }
            ]
        }));
    };

    const updateInterviewQuestion = (index, field, value) => {
        const updated = [...formData.interviewQuestions];
        updated[index][field] = value;
        setFormData({ ...formData, interviewQuestions: updated });
    };

    const removeInterviewQuestion = (index) => {
        const updated = [...formData.interviewQuestions];
        updated.splice(index, 1);
        setFormData({ ...formData, interviewQuestions: updated });
    };

    const handleExamChange = (key, value) => {
        setFormData(prev => ({
            ...prev,
            exam: {
                ...prev.exam,
                [key]: value
            }
        }));
    };

    const addExamQuestion = () => {
        handleExamChange("questions", [
            ...formData.exam.questions,
            {
                questionText: "",
                type: "text",
                options: [],
                correctAnswer: ""
            }
        ]);
    };


    const generateExamLink = () => {
        const { examTitle, durationInMinutes, questions } = formData.exam;

        if (!examTitle || !durationInMinutes || !questions.length) {
            message.error(
                "Please enter exam title, duration, and at least one question before generating the link"
            );
            return;
        }

        // Generate random exam ID (e.g., EXAM-AB12CD34)
        const randomId = Math.random().toString(36).substring(2, 8).toUpperCase(); // 6 chars
        const examId = `EXAM-${randomId}`;

        // Static exam page
        const baseUrl = "https://blueplanitcorp.com/online-exam.html";

        // Use query param
        const generatedLink = `${baseUrl}?examId=${examId}`;

        handleExamChange("examId", examId);      // store examId
        handleExamChange("examLink", generatedLink);

        message.success("Exam link generated successfully!");
    };


    const handleSubmit = async () => {
        try {
            if (!formData.designation || !formData.dept || !formData.assignedTo || !formData.employmentType || !formData.skillsRequired.length || !formData.shift) {
                message.error({
                    content: 'Please fill all mandatory fields',
                    duration: 2,
                    className: 'custom-toast-center',
                });
                return;
            }
            const selectedEmployee = details.find(
                emp => emp.id === formData.assignedTo
            );


            const payload = {
                designation: formData.designation,
                dept: formData.dept,
                assignedTo: `${selectedEmployee.firstname} ${selectedEmployee.lastname}`,
                assignerId: selectedEmployee.id,
                location: formData.location,
                employmentType: formData.employmentType,
                workMode: formData.workMode,
                numberOfOpenings: parseInt(formData.numberOfOpenings) || 0,
                experienceRequired: formData.experienceRequired,
                skillsRequired: formData.skillsRequired.split(',').map(s => s.trim()),
                jobDescription: formData.jobDescription,
                jobResponsibilities: formData.jobResponsibilities,
                salaryRange: formData.salaryRange,
                shift: formData.shift,
                reasonForHiring: formData.reasonForHiring,
                notes: formData.notes,
                approvalStatus: formData.approvalStatus,
                status: formData.status,
                RequestedBy: loginUser.firstname + " " + loginUser.lastname,
                questions: formData.hasQuestions === "Yes" ? formData.questions : [],
                interviewQuestions:
                    formData.hasInterviewQuestions === "Yes" && formData.dept
                        ? formData.interviewQuestions
                        : [],
                exam:
                    formData.hasExam === "Yes"
                        ? {
                            enabled: true,
                            examTitle: formData.exam.examTitle,
                            examLink: formData.exam.examLink,
                            durationInMinutes: Number(formData.exam.durationInMinutes),
                            instructions: formData.exam.instructions,
                            passingScore: Number(formData.exam.passingScore),
                            questions: formData.exam.questions.map(q => ({
                                questionText: q.questionText,
                                type: q.type,
                                options: q.type === "mcq" ? q.options : []
                            }))
                        }
                        : { enabled: false },

            };
            const response = await dispatch(createJobAsync(payload)).unwrap()
                .then((res) => {
                    message.success({
                        content: 'Job Requisition Created Successfully',
                        duration: 2,
                        className: 'custom-toast-center',
                    });
                })
                .catch((err) => {
                    message.error({
                        content: 'Error creating Job Requisition',
                        duration: 2,
                        className: 'custom-toast-center',
                    })
                })

        }
        catch (err) {
            console.error("Error creating job requisition:", err);
        }

    }

    return (
        <div style={{ width: "100%", marginBottom: "5px" }}>
            <Form onFinish={handleSubmit} layout='vertical'>
                <Row justify="end" gutter={16} style={{ marginBottom: "7px" }}>
                    <Col span={24} style={{ marginTop: 16, textAlign: "right" }}>
                        <Space>
                            <AntdButton label="Submit" color='primary' variant='solid' htmlType="submit" />

                            <AntdButton label="Close" color='danger' variant='solid' onClick={() => setOpen(false)} />

                        </Space>
                    </Col>
                </Row>
                <Card
                    style={{ marginBottom: "12px" }}
                    title={
                        <Space
                            direction="horizontal"
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography.Title
                                level={5}
                                style={{ marginBottom: 0, fontWeight: "bold" }}
                            >
                                Add Job Requisition
                            </Typography.Title>
                        </Space>
                    }
                >
                    <Row gutter={[16, 16]}>

                        <Col span={4}>
                            <InputField
                                label="Designation"
                                name="designation"
                                value={formData.designation}
                                onChange={(e) => handleChange("designation", e.target.value)}
                                placeholder="Enter Job Title"
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Department"
                                name="dept"
                                value={formData.dept}
                                onChange={(value) => handleChange("dept", value)}
                                placeholder="Select Department"
                                style={{ width: '100%' }}
                                options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
                            />
                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Assigned To"
                                name="assignedTo"
                                value={formData.assignedTo}
                                onChange={(value) => handleChange("assignedTo", value)}
                                style={{ width: "100%" }}
                                options={assignedToOptions}
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                }
                                placeholder="Select AssignedTo"

                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Number of Openings"
                                name="openings"
                                type="number"
                                value={formData.numberOfOpenings}
                                onChange={(e) => handleChange("numberOfOpenings", e.target.value)}
                                placeholder="Enter Number of Openings"
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Employment Type"
                                name="employmentType"
                                value={formData.employmentType}
                                onChange={(value) => handleChange("employmentType", value)}
                                placeholder="Select Employment Type"
                                style={{ width: '100%' }}
                                options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, EMPLOYMENT_TYPE])}
                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Experience Required"
                                name="experience"
                                value={formData.experienceRequired}
                                onChange={(e) => handleChange("experienceRequired", e.target.value)}
                                placeholder="Enter Experience Required"
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Work Mode"
                                name="workMode"
                                value={formData.workMode}
                                onChange={(value) => handleChange("workMode", value)}
                                style={{ width: '100%' }}
                                placeholder="Select Work Mode"
                                options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, WORK_TYPE])}

                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Skills Required"
                                name="skills"
                                type="tags"
                                value={formData.skillsRequired}
                                onChange={(e) => handleChange("skillsRequired", e.target.value)}
                                placeholder="Add required skills"
                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Budget Range"
                                name="budgetRange"
                                value={formData.salaryRange}
                                onChange={(e) => handleChange("salaryRange", e.target.value)}
                                placeholder="e.g., 4-7 LPA"
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Shift"
                                name="shift"
                                style={{ width: '100%' }}
                                value={formData.shift}
                                onChange={(value) => handleChange("shift", value)}
                                placeholder="Select Shift Type"
                                options={[
                                    { label: "General", value: "General" },
                                    { label: "Morning", value: "Morning" },
                                    { label: "Evening", value: "Evening" },
                                    { label: "Night", value: "Night" },
                                    { label: "Rotational", value: "Rotational" }
                                ]}
                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Location"
                                name="location"
                                value={formData.location}
                                onChange={(e) => handleChange("location", e.target.value)}
                                placeholder="Enter Job Location"
                            />
                        </Col>

                        <Col span={24}>
                            <RichTextEditor
                                label="Job Description"
                                ref={descriptionRef}
                                value={formData.jobDescription}
                                onChange={(value) => handleChange("jobDescription", value)}
                                placeholder="Enter job description"
                            />
                        </Col>

                        <Col span={24}>

                            <RichTextEditor
                                label="Job Responsibilities"
                                ref={responsibilitiesRef}
                                value={formData.jobResponsibilities}
                                onChange={(value) => handleChange("jobResponsibilities", value)}
                                placeholder="Enter responsibilities"
                            />
                        </Col>

                        <Col span={24}>
                            <Form.Item label="Job Related Questions">
                                <Radio.Group
                                    value={formData.hasQuestions}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange("hasQuestions", value);
                                        if (value === "No") {
                                            handleChange("questions", []);
                                        }
                                    }}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        {formData.hasQuestions === "Yes" && (
                            <Col span={24}>
                                <Card
                                    size="small"
                                    extra={
                                        <AntdButton
                                            label="Add Question"
                                            color="primary"
                                            variant="outlined"
                                            onClick={addQuestion}
                                        />
                                    }
                                >
                                    {formData.questions.length === 0 && (
                                        <p style={{ color: "#999" }}>No questions added yet.</p>
                                    )}

                                    {formData.questions.map((q, index) => (
                                        <Card key={q.id} size="small" style={{ marginBottom: 12 }}>
                                            <Row gutter={8}>
                                                <Col span={14}>
                                                    <InputField
                                                        placeholder={`Question ${index + 1}`}
                                                        value={q.label}
                                                        onChange={(e) => updateQuestion(index, "label", e.target.value)}
                                                    />
                                                </Col>

                                                <Col span={5}>
                                                    <SelectInput
                                                        value={q.type}
                                                        style={{ width: "100%" }}
                                                        onChange={(value) => updateQuestion(index, "type", value)}
                                                        options={[
                                                            { label: "Input", value: "input" },
                                                            { label: "Textarea", value: "textarea" },
                                                            { label: "Radio", value: "radio" },
                                                            { label: "Checkbox", value: "checkbox" },
                                                            { label: "Dropdown", value: "select" }
                                                        ]}
                                                    />
                                                </Col>

                                                <Col span={3}>
                                                    <CheckboxField
                                                        label="Required"
                                                        checked={q.required}
                                                        onChange={(e) =>
                                                            updateQuestion(index, "required", e.target.checked)
                                                        }
                                                    />
                                                </Col>

                                                <Col span={2}>
                                                    <AntdButton
                                                        label="✕"
                                                        color="danger"
                                                        variant="outlined"
                                                        onClick={() => removeQuestion(index)}
                                                    />
                                                </Col>
                                            </Row>

                                            {["radio", "checkbox", "select"].includes(q.type) && (
                                                <div style={{ marginTop: 10 }}>
                                                    <b>Options</b>
                                                    {q.options.map((opt, optIndex) => (
                                                        <Row key={optIndex} gutter={8} style={{ marginTop: 6 }}>
                                                            <Col span={20}>
                                                                <InputField
                                                                    placeholder={`Option ${optIndex + 1}`}
                                                                    value={opt}
                                                                    onChange={(e) =>
                                                                        updateOption(index, optIndex, e.target.value)
                                                                    }
                                                                />
                                                            </Col>
                                                            <Col span={4}>
                                                                <AntdButton
                                                                    label="✕"
                                                                    color="danger"
                                                                    variant="outlined"
                                                                    onClick={() => removeOption(index, optIndex)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    ))}

                                                    <AntdButton
                                                        label="Add Option"
                                                        variant="outlined"
                                                        onClick={() => addOption(index)}
                                                        style={{ marginTop: 8 }}
                                                    />
                                                </div>
                                            )}
                                        </Card>
                                    ))}
                                </Card>
                            </Col>
                        )}

                        <Col span={24}>
                            <Form.Item label="Interview Questions">
                                <Radio.Group
                                    value={formData.hasInterviewQuestions}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange("hasInterviewQuestions", value);
                                        if (value === "No") {
                                            handleChange("interviewQuestions", []);
                                        }
                                    }}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        {formData.hasInterviewQuestions === "Yes" && (
                            <Col span={24}>
                                <SelectInput
                                    label="Select Department"
                                    value={formData.dept}
                                    onChange={(value) => handleChange("dept", value)}
                                    placeholder="Select Department"
                                    options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
                                />
                            </Col>
                        )}

                        {formData.hasInterviewQuestions === "Yes" && formData.dept && (
                            <Col span={24}>
                                <Card
                                    size="small"
                                    extra={
                                        <AntdButton
                                            label="Add Interview Question"
                                            color="primary"
                                            variant="outlined"
                                            onClick={addInterviewQuestion}
                                        />
                                    }
                                >
                                    {formData.interviewQuestions.length === 0 && (
                                        <p style={{ color: "#999" }}>No interview questions added yet.</p>
                                    )}

                                    {formData.interviewQuestions.map((q, index) => (
                                        <Card
                                            key={index}
                                            size="small"
                                            style={{ marginBottom: 12 }}
                                        >
                                            <Row gutter={8}>
                                                <Col span={14}>
                                                    <InputField
                                                        placeholder={`Interview Question ${index + 1}`}
                                                        value={q.question}
                                                        onChange={(e) =>
                                                            updateInterviewQuestion(index, "question", e.target.value)
                                                        }
                                                    />
                                                </Col>

                                                <Col span={6}>
                                                    <SelectInput
                                                        value={q.category}
                                                        style={{ width: "100%" }}
                                                        onChange={(value) =>
                                                            updateInterviewQuestion(index, "category", value)
                                                        }
                                                        options={[
                                                            { label: "Technical", value: "Technical" },
                                                            { label: "HR", value: "HR" },
                                                            { label: "Behavioral", value: "Behavioral" },
                                                            { label: "Managerial", value: "Managerial" }
                                                        ]}
                                                    />
                                                </Col>

                                                <Col span={3}>
                                                    <CheckboxField
                                                        label="Required"
                                                        checked={q.required}
                                                        onChange={(e) =>
                                                            updateInterviewQuestion(index, "required", e.target.checked)
                                                        }
                                                    />
                                                </Col>

                                                <Col span={1}>
                                                    <AntdButton
                                                        label="✕"
                                                        color="danger"
                                                        variant="outlined"
                                                        onClick={() => removeInterviewQuestion(index)}
                                                    />
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}
                                </Card>
                            </Col>
                        )}

                        <Col span={6}>
                            <Form.Item label="Enable Online Exam">
                                <Radio.Group
                                    value={formData.hasExam}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData(prev => ({
                                            ...prev,
                                            hasExam: value,
                                            exam: value === "No" ? { enabled: false } : { ...prev.exam, enabled: true }
                                        }));
                                    }}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        {formData.hasExam === "Yes" && (
                            <Col span={24}>
                                <Card size="small" title="Exam Details">
                                    <Row gutter={12}>
                                        <Col span={12}>
                                            <InputField
                                                placeholder="Exam Title"
                                                value={formData.exam.examTitle}
                                                onChange={(e) => handleExamChange("examTitle", e.target.value)}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <InputField
                                                type="number"
                                                placeholder="Duration (minutes)"
                                                value={formData.exam.durationInMinutes}
                                                onChange={(e) => handleExamChange("durationInMinutes", e.target.value)}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <InputField
                                                type="number"
                                                placeholder="Passing Score (%)"
                                                value={formData.exam.passingScore}
                                                onChange={(e) => handleExamChange("passingScore", e.target.value)}
                                            />
                                        </Col>
                                    </Row>

                                    <Row style={{ marginTop: 12 }}>
                                        <Col span={24}>
                                            <TextareaField
                                                rows={3}
                                                placeholder="Instructions"
                                                value={formData.exam.instructions}
                                                onChange={(e) => handleExamChange("instructions", e.target.value)}
                                            />
                                        </Col>
                                    </Row>

                                    <Row style={{ marginTop: 12 }}>
                                        <Col span={24}>
                                            <Card size="small" type="inner" title="Exam Questions">
                                                {formData?.exam?.questions?.map((q, index) => (
                                                    <Card key={index} size="small" style={{ marginBottom: 12 }}>
                                                        <Row gutter={8}>
                                                            <Col span={24}>
                                                                <InputField
                                                                    placeholder={`Question ${index + 1}`}
                                                                    value={q.questionText}
                                                                    onChange={(e) => {
                                                                        const updated = [...formData.exam.questions];
                                                                        updated[index].questionText = e.target.value;
                                                                        handleExamChange("questions", updated);
                                                                    }}
                                                                />
                                                            </Col>

                                                            <Col span={8} style={{ marginTop: 8 }}>
                                                                <SelectInput
                                                                    value={q.type}
                                                                    onChange={(value) => {
                                                                        const updated = [...formData.exam.questions];
                                                                        updated[index].type = value;
                                                                        updated[index].options = value === "mcq" ? ["", "", "", ""] : [];
                                                                        handleExamChange("questions", updated);
                                                                    }}
                                                                    options={[
                                                                        { label: "text", value: "text" },
                                                                        { label: "mcq", value: "mcq" }
                                                                    ]}
                                                                />
                                                            </Col>
                                                        </Row>

                                                        {q.type === "mcq" &&
                                                            q.options.map((opt, optIndex) => (
                                                                <Row key={optIndex} gutter={8} style={{ marginTop: 6 }}>
                                                                    <Col span={20}>
                                                                        <InputField
                                                                            placeholder={`Option ${optIndex + 1}`}
                                                                            value={opt}
                                                                            onChange={(e) => {
                                                                                const updated = [...formData.exam.questions];
                                                                                updated[index].options[optIndex] = e.target.value;
                                                                                handleExamChange("questions", updated);
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            ))}

                                                        <AntdButton
                                                            label="Remove Question"
                                                            color="danger"
                                                            onClick={() => {
                                                                const updated = formData.exam.questions.filter((_, i) => i !== index);
                                                                handleExamChange("questions", updated);
                                                            }}
                                                        />
                                                    </Card>
                                                ))}

                                                <Row>
                                                    <Col span={24}>
                                                        <AntdButton
                                                            label="Add Question"
                                                            color="primary"
                                                            onClick={addExamQuestion}
                                                        />

                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    </Row>

                                    {formData.exam.examLink && (
                                        <Row style={{ marginTop: 12 }}>
                                            <Col span={24}>
                                                <Alert
                                                    type="success"
                                                    showIcon
                                                    message="Exam Link Generated"
                                                    description={
                                                        <a href={formData.exam.examLink} target="_blank" rel="noopener noreferrer">
                                                            {formData.exam.examLink}
                                                        </a>
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                    <Row style={{ marginTop: 12 }}>
                                        <Col span={24} style={{ textAlign: "right" }}>
                                            <AntdButton
                                                label="Generate Exam Link"
                                                color="primary"
                                                variant="outlined"
                                                onClick={generateExamLink}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        )}


                        <Col span={24}>
                            <TextareaField
                                label="Additional Notes"
                                name="notes"
                                value={formData.notes}
                                onChange={(e) => handleChange("notes", e.target.value)}
                                rows={3}
                                placeholder="Write any additional info"
                            />
                        </Col>
                    </Row>
                </Card>

            </Form>
        </div>
    )
};

export default AddJobRequisition;